var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{staticClass:"text-caption white--text",attrs:{"app":"","color":"secondary"}},[_c('v-img',{staticClass:"ml-5",attrs:{"contain":"","max-width":"60","src":require('@/assets/osteon-logo-text.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }